<div class="container pb-5">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-10 text-start text-md-center px-4 px-md-5 mt-4">
      <div class="d-none d-md-block mb-5">
        <h2 class="h3 fw-bold text-primary f-24 f-lg-32 mb-4">
          Paso 3: Datos bancarios
        </h2>
        <h3 class="h4 fw-bold f-lg-24 mb-3">
          ¡Último paso, {{ nombreUsuario }}!
        </h3>
        <p class="px-lg-5 f-lg-24 mb-0">
          El reembolso se hará a la cuenta bancaria que indiques en este paso.
        </p>
      </div>

      <div class="d-md-none mb-4 text-start">
        <h2 class="f-24 fw-bold text-primary mb-3">Paso 3: Datos bancarios</h2>
        <h3 class="f-18 fw-bold mb-2" style="color: #333">
          ¡Último paso, {{ nombreUsuario }}!
        </h3>
        <p class="f-16 mb-0" style="color: #555; line-height: 1.4">
          El reembolso se hará a la cuenta bancaria que indiques en este paso.
        </p>
      </div>

      <form [formGroup]="formularioBanco" class="bank-details-form text-start">
        <div class="mb-4 custom-radio">
          <label
            class="form-label fw-bold d-block mb-3 f-16"
            style="color: #333"
            >¿Es tu cuenta o la de otra persona?</label
          >
          <div class="form-check form-check-inline me-4">
            <input
              class="form-check-input"
              type="radio"
              formControlName="titularidad"
              value="own"
              id="soyTitular"
            />
            <label
              class="form-check-label f-16"
              for="soyTitular"
              style="color: #333"
              >Soy el titular</label
            >
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              formControlName="titularidad"
              value="third"
              id="noSoyTitular"
              (click)="abrirAdvertenciaTransferencia()"
            />
            <label
              class="form-check-label f-16"
              for="noSoyTitular"
              style="color: #333"
              >No soy el titular</label
            >
          </div>
        </div>

        <div class="mb-4 country">
          <select
            class="form-select tas-form-control fw-bold f-16 bg-white"
            style="color: #004686; border-color: #7b8c9e"
            formControlName="pais"
            (change)="seleccionarPais($event)"
          >
            <option value="unselect" disabled selected>
              Selecciona el país de la cuenta bancaria
            </option>
            <option
              *ngFor="let campoDinamico of camposDinamicos"
              [value]="campoDinamico.id"
            >
              {{ campoDinamico.country }}
            </option>
          </select>
        </div>

        <ng-container *ngIf="campoDinamicoActual">
          <div class="col-12 mt-4 mb-3 text-start border-bottom pb-2">
            <h4 class="fw-bold text-primary mb-1" style="font-size: 20px">
              Datos de la cuenta
            </h4>
            <p class="text-muted mb-0" style="font-size: 14px">
              Los campos con <span class="text-danger fw-bold">*</span> son
              obligatorios
            </p>
          </div>

          <div class="col-12 py-2">
            <jsonform-form
              [formData]="campoDinamicoActual.jsonDynamic"
              [customOptions]="opcionesPersonalizadas"
              (onChange)="actualizarDatosFormulario($event)"
            ></jsonform-form>
          </div>
        </ng-container>

        <div class="row justify-content-center m-0 mt-5">
          <div class="col-12 col-md-auto px-0">
            <button
              type="button"
              class="btn btn-action w-100 d-flex justify-content-center align-items-center fw-bold"
              style="
                min-height: 54px;
                padding-left: 4rem;
                padding-right: 4rem;
                border-radius: 8px;
              "
              (click)="abrirModalRevision()"
              [disabled]="cargando"
            >
              Finalizar solicitud
              <div
                *ngIf="cargando"
                class="spinner-border spinner-border-sm ms-2"
              ></div>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
